import { AppThunk } from '../../../store/reducers';
import { GET, POST, DELETE } from '../../../service/HttpMethod';
import { InitialState, ActionConstant, ActionType, RefLists } from './types';
import { toastFunction } from '../../../helpers/toastShow';

const initialState: InitialState = {
	initialList: true,
	statusCode: 0,
	refcount: 0,
	reflist: [],
	reffetching: true,
};

export const mergeUniqueProjects = (currentProjects: any[] = [], incomingProjects: any[] = []) => {
	const merged: any[] = [];
	const indexesById = new Map<string, number>();

	[...currentProjects, ...incomingProjects].forEach((project: any) => {
		const rawId = project?.id ?? project?.projectId;
		const projectId = rawId === undefined || rawId === null ? '' : String(rawId).trim();
		if (!projectId) {
			merged.push(project);
			return;
		}
		const existingIndex = indexesById.get(projectId);
		if (existingIndex === undefined) {
			indexesById.set(projectId, merged.length);
			merged.push(project);
			return;
		}
		merged[existingIndex] = { ...merged[existingIndex], ...project };
	});

	return merged;
};

const GetRefListAction = (data: RefLists): ActionType => ({
	type: ActionConstant.GET_REF_LIST,
	data,
});

export const clearRefData = (): ActionType => ({
	type: ActionConstant.CLEAR_REF_LIST,
});
export const clearStatus = (): ActionType => ({
	type: ActionConstant.CLEAR_STATUS,
});

export const getrefList = (data: any = {}): AppThunk => {
	const uid = localStorage.getItem('USER_ID');
	const getConfig = { url: `/users/${uid}/projects`, params: data };
	return async (dispatch) => {
		try {
			const { data = {} } = await GET(getConfig);
			dispatch(GetRefListAction(data.data));
		} catch (error) {
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
		}
	};
};

export function create(datas: any = {}, startDate: Date): AppThunk {
	datas.startDate = startDate;
	const postConfig = {
		data: datas,
		url: `project`,
	};
	return async (dispatch) => {
		try {
			dispatch(clearRefData());
			dispatch(clearStatus());
			const { status = 0 } = await POST(postConfig);
			dispatch({ type: ActionConstant.GET_STATUS, status });
			dispatch(getrefList());
			dispatch(toastFunction('Success', 'Project created successfully', ''));
		} catch (error) {
			dispatch(toastFunction('Error', error.data.message, ''));
			dispatch(getrefList());
		}
	};
}

export function deleteListItem(id: number): AppThunk {
	const deleteConfig = { url: `project/${id}` };
	return async function (dispatch) {
		try {
			dispatch(clearRefData());
			const { status = 0 } = await DELETE(deleteConfig);
			dispatch({ type: ActionConstant.GET_STATUS, status });
			dispatch(toastFunction('Success', 'Project deleted successfully', ''));
			dispatch(getrefList());
		} catch (error) {
			dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
			dispatch(toastFunction('Error', error.data.message, ''));
		}
	};
}

export function archiveListItem(params = { id: 0, status: false }): AppThunk {
	const archiveConfig = { url: 'archive', data: { id: params.id, status: params.status } };
	return async function (dispatch) {
		try {
			dispatch(clearRefData());
			const { status = 0, data = {} } = await POST(archiveConfig);
			dispatch({ type: ActionConstant.GET_STATUS, status });
			// console.log(message);
			dispatch(toastFunction('Success', data.message, ''));
			dispatch(getrefList());
		} catch (error) {
			dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
			dispatch(toastFunction('Error', error.data.message, ''));
			dispatch(clearRefData());
			dispatch(getrefList());
		}
	};
}
function projectReducer(state = initialState, action: ActionType): InitialState {
	switch (action.type) {
		case ActionConstant.GET_REF_LIST: {
			const { count = 0, rows = [] } = action.data;
			return {
				...state,
				reflist: mergeUniqueProjects(state.reflist, rows),
				refcount: count,
				reffetching: false,
			};
		}
		case ActionConstant.GET_STATUS: {
			return {
				...state,
				statusCode: action.status,
			};
		}
		case ActionConstant.CLEAR_REF_LIST: {
			return {
				...state,
				reflist: [],
				refcount: 0,
				reffetching: true,
			};
		}
		case ActionConstant.CLEAR_STATUS: {
			return {
				...state,
				statusCode: 0,
			};
		}

		default:
			return state;
	}
}

export default projectReducer;
